import { MUIDataTableColumn } from "mui-datatables";
import { InstructorModel } from "../../../Utils/Models";
import { Vocabulary } from "../../../Utils/Vocabulary";

export const workPointsColumns = (
  workPoints: InstructorModel[] | void
): MUIDataTableColumn[] => [
  {
    name: "productName",
    label: Vocabulary.product,
  },
  ...(workPoints?.map((workPoint: any) => {
    return {
      name: workPoint?.name,
      label: workPoint?.name,
      options: {
        customBodyRender: (value: any) => {
          return value ?? 0;
        },
      },
    };
  }) ?? []),
  {
    name: "total",
    label: Vocabulary.total,
  },
];
